// @flow

export const SOUTH_AFRICA_STATES = [
  { code: 'EC', name: 'Eastern Cape' },
  { code: 'FS', name: 'Free State' },
  { code: 'GT', name: 'Gauteng' },
  { code: 'NL', name: 'KwaZulu-Natal' },
  { code: 'LP', name: 'Limpopo' },
  { code: 'MP', name: 'Mpumalanga' },
  { code: 'NW', name: 'North-West' },
  { code: 'NC', name: 'Northern Cape' },
  { code: 'WC', name: 'Western Cape' },
];
